// ---------------------------------------------
// Product Module - DeSight Shopify Theme
// ---------------------------------------------
// Produkt-spezifische Funktionalität
// Dawn hat bereits umfangreiche Product-Funktionen
// Hier nur zusätzliche Custom-Funktionen
// ---------------------------------------------

import { ProductAPI } from '../utils/api.js';
import { $ } from '../utils/helpers.js';

/**
 * Custom Product Funktionen
 */
export class CustomProduct {
  constructor() {
    this.init();
  }

  init() {
    console.log('Custom Product initialized');
    // Hier können zusätzliche Product-Initialisierungen vorgenommen werden
  }

  /**
   * Lädt Produkt-Daten
   * @param {String} handle - Product Handle
   */
  async loadProduct(handle) {
    try {
      const product = await ProductAPI.get(handle);
      console.log('Product loaded:', product);
      return product;
    } catch (error) {
      console.error('Error loading product:', error);
    }
  }
}

